import { getData, checkQuota as serviceCheckQuota, saveData } from '../../services/common-service';
import {
    osName,
    osVersion,
    browserName,
    browserVersion,
    isMobile,
    mobileModel
} from "react-device-detect";
import moment from 'moment';

export const TaskType = {
    'RATING': { id: 16, type: 'Rating' },
    'OUTCOME': { id: 14, type: 'Outcome' }
}

export const SubTaskType = {
    'PRACTICE': { id: 1, type: 'practice' },
    'TASKS': { id: 1, type: 'tasks' },
}

export const TaskSegment = {
    'INSTRUCTION': 'Instruction',
    'PRACTICE': 'Practice',
    'PRACTICECOMPLETE': 'PracticeComplete',
    'TASK': 'Task'
};

export const TerminationType = {
    'DEMOGRAPHICS': 'DEMOGRAPHICS',
    'QUOTA': 'QUOTA',
    'TIME': 'TIME',
    'QUIZ': 'QUIZ'
}

export const SET_DEMOGRAPHICS_FOR_VERSION = 'common:setDemographicsForVersion';
export const GET_DATA = 'common:getData';
export const SET_TERMS = 'common:setTerms';
export const SET_TERMS_DECLINE = 'common:setTermsDecline';
export const SET_CONSENT = 'common:setConsent';
export const SET_CONSENT_DECLINE = 'common:setConsentDecline';
export const SET_TASK_RESPONSE = 'common:setTaskResponse';
export const SET_DEMOGRAPHICS_RESPONSE = 'common:setDemographicsResponse';
export const SET_DATA_RESPONSE = 'common:setDataResponse';
export const SET_OUTCOME_RESPONSE = 'common:setOutcomeResponse';
export const SET_SKIP_REMAINING_TASKS = 'common:skipRemainingTasks';
export const RESET_SKIPPED_TASKS = 'common:resetSkippedTasks';
export const SET_SCREEN_DURATION = 'common:setScreenDuration';
export const SET_TASK_DURATION = 'common:setTaskDuration';
export const SET_OUTCOME_DURATION = 'common:setOutcomeDuration';
export const CLEAR_RESPONSE = 'common:clearResponse';
export const SET_TERMINATION = 'videos:setTermination';
export const SET_CURRENT_PERCENTAGE = 'common:setCurrentPercentage';
export const SET_TOTAL_PERCENTAGE = 'common:setTotalPercentage';
export const SAVE = 'common:save';
export const REQUEST_START = "common:requestStart";
export const REQUEST_SAVED = "common:requestSaved";
export const REQUEST_ERROR = "common:requestError";
export const REQUEST_END = "common:requestEnd";
export const SET_ASSESSMENT_STATUS = "common:setAssessmentStatus";
export const SET_TASK_PLAYED = 'videos:setTaskPlayed';
export const SET_TIMEOUT = 'videos:setTimeout';

export const DEFAULT_RESPONSE = -9999;

const TIMEOUT = 86400; //timeout in seconds

const requestStart = () => ({
    type: REQUEST_START
})

const requestSaved = () => ({
    type: REQUEST_SAVED
})

const requestError = (error, code = "") => ({
    type: REQUEST_ERROR,
    error,
    code
})

const requestEnd = () => ({
    type: REQUEST_END
})

export const save  = () => {
    return (dispatch, getState) => {
        dispatch(requestStart());

        const { data } = getState();

        if (data.dateTimeStart === null) {
            var date = moment.utc();
            data.dateTimeStart = date.format("YYYY-MM-DD HH:mm:ss");
        }

        data.totalSessionTime = (new Date().getTime() / 1000) - (new Date(data.dateTimeStart).getTime() / 1000);
        data.operatingSystem = osName + ' ' + osVersion;
        data.browser = browserName + ' ' + browserVersion;
        data.device = isMobile ? mobileModel : osName + ' ' + osVersion;

        const localIpUrl = require('local-ip-url');
        data.location = localIpUrl('public');

        return saveData(data,
            (response) => {
                dispatch(requestSaved(response.data));
            },
            (error) => {
                dispatch(requestError(error.message));
            },
            () => {
                dispatch(requestEnd());
            }
        )
    }
}

export const getAllData = (task, callback = null) => {
    return (dispatch, getState) => {
        dispatch(requestStart());

        return getData(task,
            (response) => {
              dispatch(processGetAllData(response.data));
              if (callback) {
                callback(response.data);
              }
            },
            (error) => {
                dispatch(requestError(error.response.data));
            },
            () => {
                dispatch(requestEnd());
            } 
        )
    }
}

export const setDemographicsForVersion = (version) => ({
  type: SET_DEMOGRAPHICS_FOR_VERSION,
  version
})

const processGetAllData = (data) => ({
    type: GET_DATA,
    data
})

export const setDemographicsResponse = (name, value, child = null) => ({
    type: SET_DEMOGRAPHICS_RESPONSE,
    child,
    name,
    value
})

export const setDataResponse = (name, value) => ({
  type: SET_DATA_RESPONSE,
  name,
  value
})

export const setTaskResponse = (task, taskType, subTaskType, response, index) => ({
    type: SET_TASK_RESPONSE,
    task,
    taskType,
    subTaskType,
    response,
    index
})

export const skipRemainingTasks = (task, taskType, subTaskType) => ({
    type: SET_SKIP_REMAINING_TASKS,
    task,
    taskType,
    subTaskType,
})

export const resetSkippedTasks = (task, taskType, subTaskType) => ({
    type: RESET_SKIPPED_TASKS,
    task,
    taskType,
    subTaskType,
})

export const setOutcomeResponse = (id, response) => ({
    type: SET_OUTCOME_RESPONSE,
    id,
    response,
})


export const setDefaultTaskResponse = (task, taskType, subTaskType) => {
    return (dispatch, getState) => {
        dispatch(setTaskResponse(task, taskType, subTaskType, DEFAULT_RESPONSE));
    }
}

export const setScreenDuration = (url, start, end) => ({
    type: SET_SCREEN_DURATION,
    url,
    start,
    end
})

export const setTaskDuration = (task, taskType, subTaskType, start, end) => ({
    type: SET_TASK_DURATION,
    task,
    taskType,
    subTaskType,
    start,
    end
})

export const setOutcomeDuration = (outcome, start, end) => ({
    type: SET_OUTCOME_DURATION,
    outcome,
    start,
    end
})

export const clearResponse = (task, taskType, subTaskType) => ({
    type: CLEAR_RESPONSE,
    task,
    taskType,
    subTaskType
})

export const setTaskPlayed = (task, taskType, subTaskType) => ({
    type: SET_TASK_PLAYED,
    task,
    taskType,
    subTaskType
})

export const setTermination = (terminationReason) => ({
    type: SET_TERMINATION,
    terminationReason
})

export const checkReachedQuota = (demographics, callback) => {
    serviceCheckQuota(demographics,
        (response) => callback(response.data.reached),
        (error) => callback(false));
}

export const setTimeout = () => {
    return {
        type: SET_TIMEOUT,
        timeout: (new Date().getTime() / 1000) + TIMEOUT
    }
}

export const getTimeout = (timeout) => {
    return timeout - (new Date().getTime() / 1000);
}

export const getTasks = (tasks, type, subType) => {
    if (tasks) {
        const taskType = Object.values(tasks).find(task => task.id && task.id === type.id);

        if (taskType) {
            return taskType[subType.type];
        }
    }
}

export const getTaskTypeIdById = (id) => {
    const keys = Object.keys(TaskType);
    for (let index in keys) {
        const key = keys[index];
        if (TaskType[key].id === id) {
            return TaskType[key];
        }
    }
}

export const getTaskTypeIdByType = (type) => {
    const keys = Object.keys(TaskType);
    for (let index in keys) {
        const key = keys[index];
        if (TaskType[key].type === type) {
            return TaskType[key];
        }
    }
}

export const setTerms = (value) => ({
    type: SET_TERMS,
    value: value
});

export const setTermsDecline = (value) => ({
    type: SET_TERMS_DECLINE,
    value: value
});

export const setConsent = (value) => ({
    type: SET_CONSENT,
    value: value
});

export const setConsentDecline = (value) => ({
    type: SET_CONSENT_DECLINE,
    value: value
});

export const setAssessmentStatus = (value) => ({
    type: SET_ASSESSMENT_STATUS,
    value: value
});
